<template>
  <v-content class="bg-content">
    <div class="container">
      <v-container grid-list-xl style="padding: 5px; top: 20px;">
          <span class="title">Total </span>
          <span class="title">{{ reportname }}</span> :
          <span class="title">{{ chartData.result.length }}</span>
          <LineChart :chart-label="label" :chart-quantity="quantity" ref="chart" :report-name="reportname" />
      <!-- <v-dialog v-model="showEmailConfirmation" max-width="500" max-height="100">
        <v-card class="theme-bg-card-4">
              <v-toolbar-title style="padding: 16px;">
                <v-avatar size="60">
                  <img src="@/assets/EmailIcon.png" />
                </v-avatar>
              </v-toolbar-title>
              
          <v-spacer></v-spacer><v-spacer></v-spacer>
    <h1 class="user-speach">
      <v-flex class="space" />   
      <h1 class="typing2">
        <span>{{ speak }}</span>
      </h1>
    </h1>

        </v-card>
      </v-dialog> -->
<!--       
                    <v-card
                      dark
                      class="theme-bg-card-5 card-animate"
      
                     >  

                 <v-form
                    ref="invoiceform"
                    lazy-validation
                    aria-autocomplete="off"
                    class="form-control-2"
                  >
              
                    <form ref="form" @submit.prevent="sendEmail">

                    <v-row fluid>

  <v-button class="button">
              <v-toolbar-title style="padding: 0px;">
                <v-avatar size="60">
                  <img src="@/assets/ReviewIcon.png" />
                </v-avatar>
                    Review Email 
              </v-toolbar-title>
                    <div class="field">
                    <label>Name</label>
                    <input type="text" v-model="formFields.accountName" name="user_name">
                    <label>Email</label>
                    <input type="email" v-model="formFields.email" name="user_email">
                    <input class="submit" type="submit" @click="submitForm2" value="Send">
                    <span class="submit"></span>
                    <span class="loading"><i class="fa fa-spinner fa-spin"></i></span>
                    <span class="check"><i class="fa fa-check"></i></span>
                    </div>
                    </v-button>
                    </v-row>

                    </form>                
                  </v-form>

                    </v-card> -->

      </v-container>
    </div>
  </v-content>
</template>
<script>
import LineChart from '../components/LineChart.vue';
export default {
  name: 'Analytics',
  components: { LineChart },
  data() {
    return {
      quantity: [],
      label: [],
      chartData: [],
      monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      reportname: '',
    };
  },
  methods: {
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);

     speech.onend = function() {
      setTimeout(() => {
      Event.$emit('speakModeOn');
      }, 3200);
     };
    },
    async getInvoicesList() {
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}invoice-form/all`);
      this.chartData = await response.json();
      this.reportname = 'Invoice';

      let group = this.chartData.result.reduce((r, o) => {
        
        let date = new Date(o.invoiceDate);
        let month = date.getMonth();
        let monthName = this.monthNames[month];
        // r[monthName] ? (r[monthName].count += o.quantity) : (r[monthName] = { monthName: monthName, count: o.quantity });
        r[monthName] ? r[monthName].count++ : (r[monthName] = { monthName: monthName, count: 12 });
        return r;
      }, {});
      this.label = Object.keys(group);
      this.quantity = Object.keys(group).map((key) => group[key]['count']);
    },
    async getSalesList() {
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}invoice-form/all`);
      this.chartData = await response.json();
      this.reportname = 'Sale';

      let group = this.chartData.result.reduce((r, o) => {
        let date = new Date(o.invoiceDate);
        let rDate = date.getDate(); // 1-31
        r[rDate] ? r[rDate].count++ : (r[rDate] = { rDate: rDate, count: 1 });
        return r;
      }, {});
      this.label = Object.keys(group);
      this.quantity = Object.keys(group).map((key) => group[key]['count']);
    },
    async GetDailySalesAmountList() {
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}invoice-form/all`);
      this.chartData = await response.json();
      this.reportname = 'Daily Sale';

      let group = this.chartData.result.reduce((r, o) => {
        let date = new Date(o.invoiceDate);
        let rDate = date.getUTCDate(); // 1-31

        r[rDate] ? (r[rDate].count += o.total) : (r[rDate] = { rDate: rDate, count: o.total });
        return r;
      }, {});
      this.label = Object.keys(group);
      this.quantity = Object.keys(group).map((key) => group[key]['count']);
    },
    // async GetDailySalesAmountList() {
    //   const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}invoice-form/all`);
    //   this.chartData = await response.json();
    //   this.reportname = 'Daily Sale';

    //   let group = this.chartData.result.reduce((r, o) => {
    //     let date = new Date(o.invoiceDate);
    //     let rDate = date.getDate(); // 1-31
    //     r[rDate] ? (r[rDate].count += o.total) : (r[rDate] = { rDate: rDate, count: o.total });
    //     return r;
    //   }, {});
    //   this.label = Object.keys(group);
    //   this.quantity = Object.keys(group).map((key) => group[key]['count']);
    // },
    // async GetDailyInvoiceTotalSum() {
    //   const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}invoice-form/all`);
    //   this.chartData = await response.json();
    //   this.reportname = 'Invoice Total Daily';

    //   let group = this.chartData.result.reduce((r, o) => {
    //     let date = new Date(o.orderDate);
    //     let rDate = date.getDate();
    //     r[rDate] ? (r[rDate].count += o.total) : (r[rDate] = { count: o.total });
    //     return r;
    //   }, {});
    //   this.label = Object.keys(group);
    //   this.quantity = Object.keys(group).map((key) => group[key]['count']);
    // },
    async GetDailyInvoiceTotalSum() {
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}invoice-form/all`);
      this.chartData = await response.json();
      this.reportname = 'Invoice Total Daily';

      let group = this.chartData.result.reduce((r, o) => {
        let date = new Date(o.invoiceDate);
        let month = date.getMonth();
        let monthName = this.monthNames[month];
        // r[monthName] ? (r[monthName].count += o.quantity) : (r[monthName] = { monthName: monthName, count: o.quantity });
        r[monthName] ? (r[monthName].count += o.total) : (r[monthName] = { count: o.total });
        // let rDate = date.getDate("yyyy-MM-dd'T'HH:mm:ss");
        // r[rDate] ? (r[rDate].count += o.total) : (r[rDate] = { count: o.total });
        return r;
      }, {});
      this.label = Object.keys(group);
      this.quantity = Object.keys(group).map((key) => group[key]['count']);
    },
    async GetCurrentMonthDailySalesAmountList() {
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}invoice-form/all`);
      this.chartData = await response.json();
      this.reportname = 'Month Daily Sale';

      let group = this.chartData.result.reduce((r, o) => {
        let date = new Date(o.invoiceDate);
        let month = date.getMonth();
        let rDate = this.monthNames[month];
        r[rDate] ? (r[rDate].count += o.total) : (r[rDate] = { rDate: rDate, count: o.total });
        return r;
      }, {});
      this.label = Object.keys(group);
      this.quantity = Object.keys(group).map((key) => group[key]['count']);
    },
    async getCurrentMonthDailySalesList() {
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}invoice-form/all`);
      this.chartData = await response.json();
      this.reportname = 'Current Month Daily Sale';

      let group = this.chartData.result.reduce((r, o) => {
        let date = new Date(o.invoiceDate);
        let month = date.getMonth();
        let rDate = this.monthNames[month];
        // r[rDate] ? (r[rDate].count += o.total) : (r[rDate] = { rDate: rDate, count: o.total });
        r[rDate] ? r[rDate].count++ : (r[rDate] = { rDate: rDate, count: 1 });
        // r[rDate] ? (r[rDate].count += o.total) : (r[rDate] = { rDate: rDate, count:1 o.total  });
        return r;
      }, {});
      this.label = Object.keys(group);
      this.quantity = Object.keys(group).map((key) => group[key]['count']);
    },
    async GetCurrentMonthSalesAmountList() {
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}invoice-form/all`);
      this.chartData = await response.json();
      this.reportname = 'Current Month Sale';

      let group = this.chartData.result.reduce((r, o) => {
        let date = new Date(o.invoiceDate);
        let month = date.getMonth();
        let rDate = this.monthNames[month];
        r[rDate] ? (r[rDate].count += o.total) : (r[rDate] = { rDate: rDate, count: o.total });
        return r;
      }, {});
      this.label = Object.keys(group);
      this.quantity = Object.keys(group).map((key) => group[key]['count']);
    },
    async getTodaysTotalSalesAmountList() {
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}invoice-form/all`);
      this.chartData = await response.json();
      this.reportname = 'Today Sale';

      let group = this.chartData.result.reduce((r, o) => {
        let date = new Date(o.invoiceDate);
        let rDate = date.getdate(); // 1-31
        r[rDate] ? (r[rDate].count += o.total) : (r[rDate] = { rDate: rDate, count: o.total });
        return r;
      }, {});
      this.label = Object.keys(group);
      this.quantity = Object.keys(group).map((key) => group[key]['count']);
    },
    async getThisWeeksInvoiceTotalSum() {
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}invoice-form/all`);
      this.chartData = await response.json();
      this.reportname = 'Weekly Sales';

      let group = this.chartData.result.reduce((r, o) => {
        let date = new Date(o.invoiceDate);
        let week = date.getdate(); // 1-31
        r[week] ? (r[week].count += o.total) : (r[week] = { week: week, count: o.total });
        return r;
      }, {});
      this.label = Object.keys(group);
      this.quantity = Object.keys(group).map((key) => group[key]['count']);
    },
    async getPOList() {
      // const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}invoice-form/all`);
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}purchaseorder-form/all`);
      this.chartData = await response.json();
      this.reportname = 'Purchase Order';
      console.log(this.chartData);
      let group = this.chartData.result.reduce((r, o) => {
        let date = new Date(o.purchaseorderDate);
        let month = date.getMonth();
        let monthName = this.monthNames[month];
        r[monthName] ? r[monthName].count++ : (r[monthName] = { monthName: monthName, count: 1 });
        return r;
      }, {});
      this.label = Object.keys(group);
      this.quantity = Object.keys(group).map((key) => group[key]['count']);
    },
  },
  computed: {},
  
  mounted() {

    // this.getInvoicesList();
    Event.$on('graphs', (data) => {
      console.log('graphs');
      if (data.indexOf('invoice') != -1) {
        this.getInvoicesList();
           setTimeout(() => {
        this.readOutLoud('Here is the ' + this.reportname + ' report you requested. There are a total of ' + this.chartData.result.length + ' confirmed' + this.reportname +'s. ');
      }, 3300);

      } else if (data.indexOf('purchase order') != -1) {
        this.getPOList();
        setTimeout(() => {
        this.readOutLoud('Here is the ' + this.reportname + ' report you requested. There are a total of ' + this.chartData.result.length + ' confirmed' + this.reportname +'s. ');
      }, 3300);
      } else if (data.indexOf('sale') != -1 || data.indexOf('sales') != -1) {
        this.getSalesAmountList();
        setTimeout(() => {
        this.readOutLoud('Here is the ' + this.reportname + ' report you requested. There are a total of ' + this.chartData.result.length + ' confirmed' + this.reportname +'s. ');
      }, 3300);
      } else if (data.indexOf('months') != -1 || data.indexOf('monthly') != -1) {
        this.GetCurrentMonthSalesAmountList();
        setTimeout(() => {
        this.readOutLoud('Here is the ' + this.reportname + ' report you requested. There are a total of ' + this.chartData.result.length + ' confirmed' + this.reportname +'s. ');
      }, 3300);
      // } else if (data.indexOf('current') != -1 || data.indexOf('currents') != -1) {
      //   this.GetDailySalesAmountList();
      } else if (data.indexOf('todays') != -1 || data.indexOf('today') != -1) {
        this.GetDailyInvoiceTotalSum();
        setTimeout(() => {
        this.readOutLoud('Here is the ' + this.reportname + ' report you requested. There are a total of ' + this.chartData.result.length + ' confirmed' + this.reportname +'s. ');
      }, 3300);
      } else if (data.indexOf('amount') != -1 || data.indexOf('total') != -1) {
        this.getTodaysTotalSalesAmountList();
        setTimeout(() => {
        this.readOutLoud('Here is the ' + this.reportname + ' report you requested. There are a total of ' + this.chartData.result.length + ' confirmed' + this.reportname +'s. ');
      }, 3300);
      } else if (data.indexOf('24 hour') != -1 || data.indexOf('24 hours') != -1) {
        this.get24HourSalesAmountList();
        setTimeout(() => {
        this.readOutLoud('Here is the ' + this.reportname + ' report you requested. There are a total of ' + this.chartData.result.length + ' confirmed' + this.reportname +'s. ');
      }, 3300);
      } else if (data.indexOf('weekly') != -1 || data.indexOf('weeks') != -1) {
        this.getThisWeeksInvoiceTotalSum();
        setTimeout(() => {
        this.readOutLoud('Here is the ' + this.reportname + ' report you requested. There are a total of ' + this.chartData.result.length + ' confirmed' + this.reportname +'s. ');
      }, 3300);
      }
      setTimeout(() => {
        Event.$emit('initLineChart');
      }, 1000);
    });
  },
  beforeMount() {},
};
</script>

<style scoped src="../components/css/Style.css">
@import '../components/css/Style.css';
.title {
  font-size: 16px;
  color: #fff;
}
</style>